import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

const q4: PartialCarConfiguration = {
	combinations: ['trimLine', 'packages', 'paint', 'rims', 'headlights', 'interiorPackages', 'steeringWheels'],
};

const q4etron: PartialCarConfiguration = {
	...q4,
};

const q4sbetron: PartialCarConfiguration = {
	...q4,
};

export { q4etron, q4sbetron };
